import { render, staticRenderFns } from "./TenantBox.vue?vue&type=template&id=640b4a07&"
import script from "./TenantBox.vue?vue&type=script&lang=js&"
export * from "./TenantBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports